export const FilterConstants = {
  ExcludedFromClearing: ['orderBy', 'tpackage', 'purchase', 'cosmosInstallments'],
  filterItemBorder: 15,
  yettelHomeInternet: 'Yettel kućni internet',
  bundlePackage: 'bpackage',
};

export const FilterTypes = {
  BRAND: 'brand',
  OPSYSTEMS: 'opsystems',
  POSSIBILITIES: 'possibilities',
  CATEGORY: 'category',
  COLOR: 'color',
  TARIFF_PACKAGE: 'tpackage',
};
